export default function () {
  const toast = useToast()
  const { t } = useI18n()
  const localePath = useLocalePath()
  const { candidateLogout } = useCandidate()
  const { internalUserLogout } = useInternalUser()

  async function handleError(error: any) {
    if (error instanceof FetchErrorUnauthorized) {
      await internalUserLogout()
      // TODO navigateTo(localePath('landing-employer'))

      await candidateLogout()
      navigateTo(localePath('landing-candidate'))

      toast.add({ severity: 'info', summary: t('Sitzung abgelaufen'), detail: t('Bitte melden Sie sich erneut an.') })

      return
    }
    else if (error instanceof FetchErrorServer) {
      toast.add({ severity: 'error', summary: t('Server-Fehler'), detail: `${error.status} ${error.statusText} (${error.uuid}, ${error.path})` })
      return
    }
    else if (error instanceof FetchErrorMisc) {
      toast.add({ severity: 'error', summary: t('Anforderungsfehler'), detail: `${error.status} ${error.statusText}` })
      return
    }

    if (error.error) {
      error = error.error
    }

    if (!(error instanceof Error)) {
      if (typeof error.message === 'string') {
        const config = error.config
        error = new Error(error.message)
        error.config = config
      }
      else if (typeof error === 'string') {
        error = new Error(error)
      }
      else {
        error = new Error(JSON.stringify(error))
      }
    }

    toast.add({ severity: 'error', summary: t('Fehler'), detail: `${error}` })

    console.warn(error)

    const xhr = new XMLHttpRequest()
    xhr.open('POST', '/api/frontend-error', true)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.setRequestHeader('x-url', useRequestURL().toString())
    xhr.send(JSON.stringify({ name: error.name, message: error.message, stack: error.stack }))
  }

  return {
    handleError,
  }
}
